<template>
  <div class="my-3">
    <label>Add New Program</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 col-lg-12 border p-3">
        <form v-on:submit.prevent="addProgramOrContest()">
          <div class="row my-3">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <label>Name</label>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <b-form-input type="text" v-model="Name"></b-form-input>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <label>Default points</label>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <b-form-input type="text" v-model="DefaultPoints"></b-form-input>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <label>Select Location or companies for this program/contest</label>
              <p>Hold down the control key to select multiple locations.</p>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <b-form-select v-model="Companies" :options="CompaniesOption" :select-size="4" multiple></b-form-select>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <label>Add Points: Default Congratulatory Note</label>
              <p>
                This note appears in the customers account history next to the added points.
              </p>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <b-form-textarea
                v-model="CongratulatoryNote"
                type="text"
                id="textarea"
                placeholder="Enter Your Message Here..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </div>
          </div>
          <!-- <div class="row my-3">
            <div class="col-sm-12 col-lg-6 col-md-6" style="display: flex">
              <b-form-checkbox
                id="checkbox-1"
                v-model="PostCongratulatoryNote"
                name="checkbox-1"
                :value="true"
              >
              </b-form-checkbox>
              <p>
                Also post Default Congratulatory Note on the Customer's
                Notifications section of the Social Recognition Wall
              </p>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6" style="display: flex">
              <b-form-checkbox
                id="checkbox-2"
                v-model="PostSummaryNotification"
                name="checkbox-2"
                :value="true"
              >
              </b-form-checkbox>
              <p>
                Post summary notification on General News Feed section of the
                Social Recognition Wall
              </p>
            </div>
          </div> -->
          <div class="row my-3">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <label>Add Points: Default Email Subject</label>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <b-form-input id="emailSubject" type="text" v-model="EmailSubject"></b-form-input>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <label>Add Points: Default Email Message</label>
              <p>
                This note is emailed to the recipients when you add points using this program/contest.
              </p>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <b-form-textarea
                id="emailMessage"
                v-model="EmailMessage"
                placeholder="Enter Your Message Here..."
                rows="3"
                max-rows="6"
                type="text"
              ></b-form-textarea>
            </div>
          </div>
          <input class="btn btn-primary btn-lg btn-sm-block mr-2" type="submit" name="add" value="Add This Program/Contest" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointProgramsNewProgramContest',

  data() {
    return {
      Name: '',
      DefaultPoints: null,
      Companies: [],
      CompaniesOption: [],
      CongratulatoryNote: '',
      PostCongratulatoryNote: false,
      PostSummaryNotification: false,
      EmailSubject: '',
      EmailMessage: '',
    };
  },

  methods: {
    addProgramOrContest: function() {
      const allCompanies = this.Companies.includes(null);

      const params = {
        name: this.Name,
        userClientId: +this.getUserClients.client,
        client_ids: this.Companies,
        presetPoints: +this.DefaultPoints,
        presetCongratulatoryNote: this.CongratulatoryNote,
        presetEmailMessage: this.EmailMessage,
        presetEmailSubject: this.EmailSubject,
        postContratulatoryNote: this.PostCongratulatoryNote,
        postSummaryNotification: this.PostSummaryNotification,
      };

      if (allCompanies) {
        const allCompanyArray = this.CompaniesOption.filter((client) => client.value !== null);
        params.client_ids = allCompanyArray.map((client) => client.value);
      }

      if (params.name) {
        this.$store.dispatch('systemMessage/setMessage', {
          message: '',
        });

        this.$store
          .dispatch('adminPointPrograms/insertProgram', params)
          .then((programId) => {
            this.$store.dispatch('systemMessage/setMessage', {
              message: 'Your new programs has been created.',
            });

            this.$store.dispatch('adminPointPrograms/fetchProgrammes', {
              clientId: +this.getUserClients.client ? +this.getUserClients.client : 0,
            });

            this.$router.push({
              name: 'AdminPointPrograms',
            });
          })
          .catch(() => {
            console.log('some error occures in admin point programs');
          });
        console.log('finally done.');
      } else {
        console.log(false);
        this.$store.dispatch('systemMessage/setMessage', {
          message: 'Your Program must atleast have a name',
        });
      }
    },

    setMessage: function() {
      this.$store.dispatch('systemMessage/setMessage', {
        message: '',
      });
    },
  },

  computed: {
    authorizedClients() {
      return this.$store.getters['adminPointPrograms/getAuthorizedClients'];
    },
    getUserClients() {
      return this.$store.getters['user/getUserClients'];
    },
    getClientPrograms() {
      return this.$store.getters['adminPointPrograms/getClientPrograms'];
    },
  },

  watch: {
    authorizedClients(authorizedClients) {
      var datas = [{ value: null, text: 'Apply to all locations' }];
      authorizedClients.map(function(data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      this.CompaniesOption = datas;
    },
  },

  created() {
    this.setMessage();
    this.$store.dispatch('adminPointPrograms/fetchAuthorizedClients');
  },
};
</script>

<style lang="scss" scoped></style>
